export class RequestBaseClass {
    getStatusClass(status) {
      if (status === 'closed') {
        return 'label-danger';
      } else if (status === 'new') {
        return 'label-success';
      } else if (status === 'open') {
        return 'label-info';
      }
    }
  
    getStatusMsg(status) {
      if (status === 'closed') {
        return 'Closed';
      } else if (status === 'new') {
        return 'New';
      } else if (status === 'open') {
        return 'Open';
      }
    }
  }
  


// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/shared/common-request-support/request-base-class.ts